import { Newsletter } from 'ui/components';

export const NewsletterSignupFeature: React.FC<Content.NewsletterSignup> = ({ content }) => <Newsletter {...content?.properties} />;
